import { rgb, PageSizes, StandardFonts } from 'pdf-lib'
import genmincho from '../../font/SourceHanSerif-Medium_extracted.otf'
import genmincho_bold from '../../font/SourceHanSerif-Bold_extracted.otf'
import fontkit from '@pdf-lib/fontkit'

import { dayWeekToString, decimalToPercentDecimal, getAmPmHour, getMonthDateDisplay, getYearMonthDateDisplay } from '../../utils/utils'
import { createPDFDocument, customDrawText, getFontArrayBuffer } from './pdf_create'
import { drawTextInBox, X_ALIGN_CENTER, X_ALIGN_LEFT, X_ALIGN_RIGHT } from './pdfUtil/drawTextInBox'
import { getDisplayOriginWithOther, getDisplaySize } from '../../utils/Items'
import { postMarketPriceSearchInfoListAPI, postMarketPriceSearchTableInfoListAPI } from '../../http/api/MarketPriceAPI'
import { DELIVERY_PRICE_ADDITION_CD_RATE, getDeliveryPriceCalculation, getOutputDestination, getOutputShippingDateWithDay, getPrimePrice, getProductPartitionList, filterPartition, getSellingPrice, sampleDestination, getPrintPages } from '../../utils/orderForm'
import { getShopsGroupingByCustomer } from '../../utils/customerShop'
import { getDaysBetween } from '../../utils/calendar'
import Decimal from 'decimal.js'

export const getVerticalOrderFormPageParameter = (width, height, fonts, shops, destinations, shippingDateInfo, pdfSetting) => {

  const {columnNumber, shopSummary, productTypePartition, unitPrice, contact, deadlineHourOutput, orderQuantityOutput, skipOrderUnit, datePartition, skipRemark, isUsingSellingPrice, isUsingDeliveryPrice, isUsingOriginalMarketPrice, isViewOriginalCost, isSendingAgain, printPageStr, outputPrice, asSendingLabel} = pdfSetting;

  const margin = 20
  const marginLeft = 15
  const marginRight = 15

  const headerHeight = 100
  const tableStart_y = height - margin - headerHeight

  const footerHeight = 0
  const tableEnd_y = margin + footerHeight

  const rowNumber = columnNumber === 1 ? 26: 28;

  const destinationNumber = destinations.length;

  let shopNumber = shops.length;

  const dateList = datePartition
    ? getDaysBetween(shippingDateInfo.shippingDateFrom, shippingDateInfo.shippingDateTo)
    : [];

  const shopNames= shops.map((shopInfo) => shopInfo.shopName);

  const customerShopList = getShopsGroupingByCustomer(shops);
  const outputCustomerName = shopSummary && orderQuantityOutput && customerShopList.length >= 2;

  let tableHeaderRowSpan = 1;  
  let orderQuantityColumnNumber = 1;

  if (!orderQuantityOutput) {
    orderQuantityColumnNumber = 0;
  } else if (datePartition) {
    tableHeaderRowSpan = 1.3;
    orderQuantityColumnNumber = dateList.length;
  } else if (shopSummary) {
    tableHeaderRowSpan = (outputCustomerName ? 2 : 1);
    orderQuantityColumnNumber = shops.length;
  }

  const rowHeight = (tableStart_y - tableEnd_y) / (rowNumber + tableHeaderRowSpan)
  const tableHeaderHeight = rowHeight * tableHeaderRowSpan;
  const tableDataStart_y = tableStart_y - tableHeaderHeight;
  const shopHeaderStart_y =  tableDataStart_y + rowHeight;
 
  // （印刷用紙幅 - 左右余白マージン）/ １ページあたりの列分割数 
  const columnWidth = (width - marginLeft - marginRight) / columnNumber;

  // 1店舗辺りの出力列幅
  let shopColumnWidth;
  // 店舗をまとめて出力する場合、４店舗より多いと店舗列が表示しきれなくなるため、
  // 店舗列幅を縮小する
  const isShopColumnReduction = ((shopSummary === true) && (shopNumber > 4));
  const shopColumnReductionCoef = ((isShopColumnReduction && !skipRemark) ? 0.8 : 1.0);

  if (asSendingLabel) {
    // 送り状出力の場合、通常の2倍の幅をもたせる
    shopColumnWidth = columnWidth * (columnNumber === 1 ? 0.08 : 0.1) * 2;
  } else {
    shopColumnWidth = columnWidth * (columnNumber === 1 ? 0.08 : 0.1) * shopColumnReductionCoef;
  }

  // 納品価格欄・案内価格欄
  let originalMarketPriceLeft = columnWidth;
  if (outputPrice && isUsingOriginalMarketPrice) {
    originalMarketPriceLeft = columnWidth * (columnNumber === 1 ? 0.91 : 0.86);
  }

  // 備考欄
  let remarkColumnLeft = originalMarketPriceLeft;
  if (!skipRemark) {
    // 店舗をまとめて出力する場合、４店舗より多いと店舗列が表示しきれなくなるため、
    // 備考列幅を縮小する
    const remarkColumnReductionMargin = (isShopColumnReduction ? 0.03 : 0.00);
    remarkColumnLeft = originalMarketPriceLeft * ((columnNumber === 1 ? 0.87 : 0.82) + remarkColumnReductionMargin);
  }

  const orderUnitColumnLeft = remarkColumnLeft - shopColumnWidth * orderQuantityColumnNumber;
 
  // 価格欄レイアウト
  let nameColumnLeft, placeColumnLeft, sizeColumnLeft, priceColumnLeft = 0;
  let primePriceLeft, sellingPriceMarkUpRateLeft, sellingPriceLeft = 0;

  if (outputPrice && isUsingSellingPrice && !isViewOriginalCost) {
    nameColumnLeft = orderUnitColumnLeft * 0;
    placeColumnLeft = orderUnitColumnLeft * 0.25;
    sizeColumnLeft = orderUnitColumnLeft * 0.4;
    priceColumnLeft = orderUnitColumnLeft * 0.58;
    sellingPriceLeft = orderUnitColumnLeft * 0.58;
    primePriceLeft = orderUnitColumnLeft * 0.73;
    sellingPriceMarkUpRateLeft = orderUnitColumnLeft * 0.88;

  } else if (outputPrice) {
    nameColumnLeft = orderUnitColumnLeft * 0;
    placeColumnLeft = orderUnitColumnLeft * (columnNumber === 1 ? 0.4 : 0.37);
    sizeColumnLeft = orderUnitColumnLeft * (columnNumber === 1 ? 0.6 : 0.58);
    priceColumnLeft = orderUnitColumnLeft * 0.82;
  } else {
    nameColumnLeft = orderUnitColumnLeft * 0;
    placeColumnLeft = orderUnitColumnLeft * (columnNumber === 1 ? 0.5 : 0.46);
    sizeColumnLeft = orderUnitColumnLeft * (columnNumber === 1 ? 0.73 : 0.7);
    priceColumnLeft = orderUnitColumnLeft * 1;
  }

  return {
    ...pdfSetting,
    width,
    height,
    margin,
    marginLeft,
    marginRight,
    headerHeight,
    tableStart_y ,  
    footerHeight ,
    tableEnd_y ,  
    rowNumber ,
    columnNumber ,
    shopNumber,
    rowHeight ,
    tableHeaderHeight,
    shopHeaderStart_y,
    tableDataStart_y,
    columnWidth ,
    nameColumnLeft ,
    placeColumnLeft ,
    sizeColumnLeft ,
    priceColumnLeft ,
    orderUnitColumnLeft,
    remarkColumnLeft,
    shopColumnWidth,
    fonts,
    destinations,
    destinationNumber,
    shopNames,
    shops,
    contact,
    skipOrderUnit,
    deadlineHourOutput,
    orderQuantityOutput,
    customerShopList,
    outputCustomerName,
    shopSummary,
    productTypePartition,
    unitPrice,
    orderQuantityColumnNumber,
    dateList,
    isUsingSellingPrice,
    primePriceLeft,
    sellingPriceMarkUpRateLeft,
    sellingPriceLeft,
    isUsingOriginalMarketPrice,
    originalMarketPriceLeft,
    isUsingDeliveryPrice,
    isViewOriginalCost,
    isShopColumnReduction,
    isSendingAgain,
    printPageStr
  }
}

// 価格表　ヘッダ部分作成
export const createVerticalOrderFormHeader = (marketPriceInfo, page, pageIndex, title, destination, shippingDateInfo, pageParameter, outputPageIndex) => {

  const {
    width,
    height,
    margin,
    marginLeft,
    marginRight,
    fonts,
    contact,
    deadlineHourOutput,
    isUsingDeliveryPrice,
    isUsingOriginalMarketPrice,
    isSendingAgain,
    outputPrice,
    asSendingLabel
  } = pageParameter;
  const { orderDeadlineHour, deliveryPriceAdditionCd, deliveryPriceAdditionAmount } = marketPriceInfo;
  const todayStr = getYearMonthDateDisplay(new Date());
  const shippingDateStr = getOutputShippingDateWithDay(shippingDateInfo.shippingDateFrom, shippingDateInfo.shippingDateTo);
  
  // 担当者
  if(pageParameter.directorEmployee){
    customDrawText(page, `担当者：${pageParameter.directorEmployee}`, {
      x: marginLeft,
      y: height - margin - 10,
      size: 10,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    });
  }

  // 発行日
  if (!asSendingLabel) {
    customDrawText(page, todayStr, {
      x: width - marginRight - 7 * todayStr.length,
      y: height - margin - 10,
      size: 10,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    });
  }

  // あて名
  customDrawText(page, destination, {
    x: marginLeft,
    y: height - margin - 35,
    size: 18,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })

  // 再送
  if (isSendingAgain) {
    drawTextInBox(
      page, 
      "再送",
      {x1: width - marginRight - 45, x2: width - marginRight, y1: height - margin - 10, y2: height - margin - 35},
      {xAlign: X_ALIGN_RIGHT, font: fonts.mincho_bold_font, size: 20}
    )

    page.drawLine({
      start: { x: width - marginRight - 45, y: height - margin - 35 },
      end: { x:width - marginRight, y: height - margin - 35 },
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    page.drawLine({
      start: { x: width - marginRight - 45, y: height - margin - 37 },
      end: { x:width - marginRight, y: height - margin - 37 },
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })
  }

  page.drawLine({
    start: { x: marginLeft, y: height - margin - 40 },
    end: { x: marginLeft + destination.length * 18, y: height - margin - 40 },
    thickness : 2,
    color: rgb(0, 0, 0),
    opacity : 1
  })

  customDrawText(page,title, {
    x: marginLeft + 40,
    y: height - margin - 65,
    size: 18,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })

  if (outputPageIndex) {
    customDrawText(page,"No." + (pageIndex + 1).toString(), {
      x: marginLeft + 140,
      y: height - margin - 65,
      size: 18,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })
  }

  customDrawText(page,'納品日：' + shippingDateStr, {
    x: marginLeft,
    y: height - margin - 90,
    size: shippingDateInfo.shippingDateTo ? 12 : 15,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })

  const orderDeadline = getAmPmHour(orderDeadlineHour);

  // 発注時間注意
  if (deadlineHourOutput) {
    customDrawText(page,`※発注は、${orderDeadline.amPm}`, {
      x: marginLeft + (isUsingDeliveryPrice && isUsingOriginalMarketPrice ? 233 : 315),
      y: height - margin - 58,
      size: 10,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })

    customDrawText(page,`${orderDeadline.hour}時`, {
      x: marginLeft + (isUsingDeliveryPrice && isUsingOriginalMarketPrice ? 308 : 390),
      y: height - margin - 58,
      size: 15,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })

    //時間は２数字ならスペースを開ける
    const orderDeadlineHourSpaceAddition = orderDeadline.hour.toString().length > 1 ? 8 : 0;
    customDrawText(page,'までに', {
      x: marginLeft + (isUsingDeliveryPrice && isUsingOriginalMarketPrice ? 333 : 415) + orderDeadlineHourSpaceAddition,
      y: height - margin - 58,
      size: 10,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })

    customDrawText(page,'お願い致します', {
      x: marginLeft + (isUsingDeliveryPrice && isUsingOriginalMarketPrice ? 363 + orderDeadlineHourSpaceAddition : 327),
      y: height - margin - (isUsingDeliveryPrice && isUsingOriginalMarketPrice ? 58 : 74),
      size: 10,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })
  }

  // 納品価格注意
  if (outputPrice && isUsingDeliveryPrice && isUsingOriginalMarketPrice) {
    Decimal.rounding = Decimal.ROUND_HALF_CEIL;

    /** 納品価格増量分の説明 */
    let additionExplanation =
      (deliveryPriceAdditionCd === DELIVERY_PRICE_ADDITION_CD_RATE) 
        ? `各案内価格の${decimalToPercentDecimal(new Decimal(deliveryPriceAdditionAmount))}%`
        : `各商品に対し${parseInt(new Decimal(deliveryPriceAdditionAmount).round().toNumber())}円`;

    customDrawText(page,`※手数料として、${additionExplanation}を頂戴いたします`, {
      x: marginLeft + 200,
      y: height - margin - 74,
      size: 10,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })

  }

  // 税抜価格注意
  if (outputPrice) {
    let excludeTaxPriceName = isUsingDeliveryPrice ? "案内価格" : "納品価格";

    customDrawText(page, `※${excludeTaxPriceName}は税抜きです`, {
      x: marginLeft + (isUsingDeliveryPrice ? 325 : 315),
      y: height - margin - 90,
      size: 10,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })
  }

  // 青果連絡先
  customDrawText(page, '丸伊伊那青果(株)', {
    x: width - marginRight - 120,
    y: height - margin - (contact === 1 ? 52 : 72),
    size: 15,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })

  customDrawText(page, 'TEL: 0265-74-5588', {
    x: width - marginRight - 80,
    y: height - margin - (contact === 1 ? 64 : 84),
    size: 8,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })

  customDrawText(page, 'FAX: 0265-73-7210', {
    x: width - marginRight - 80,
    y: height - margin - (contact === 1 ? 74 : 94),
    size: 8,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })

  if (contact === 1) {
    customDrawText(page, '野菜窓口(安藤) 090-1058-3018', {
      x: width - marginRight - 120,
      y: height - margin - 84,
      size: 8,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })

    customDrawText(page, '果物窓口(杉本) 090-7947-9328', {
      x: width - marginRight - 120,
      y: height - margin - 94,
      size: 8,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })
  }
}

// 価格表の骨格作成
export const createVerticalOrderFormTableBones = (page, pageParameter) => {

  const {
    width,
    margin,
    marginLeft,
    marginRight,
    tableStart_y,
    tableEnd_y,
    rowNumber,
    columnNumber,
    rowHeight,
    columnWidth,
    nameColumnLeft,
    placeColumnLeft,
    sizeColumnLeft,
    priceColumnLeft,
    orderUnitColumnLeft,
    remarkColumnLeft,
    shopColumnWidth,
    fonts,
    shops,
    shopSummary,
    outputCustomerName,
    tableHeaderHeight,
    tableDataStart_y,
    shopHeaderStart_y,
    orderQuantityOutput,
    unitPrice,
    dateList,
    datePartition,
    skipRemark,
    isUsingSellingPrice,
    sellingPriceMarkUpRateLeft,
    primePriceLeft,
    originalMarketPriceLeft,
    isUsingOriginalMarketPrice,
    isUsingDeliveryPrice,
    isViewOriginalCost,
    isShopColumnReduction,
    outputPrice,
    asSendingLabel
  } = pageParameter
  
  const SHOP_NAME_SPLIT_LENGTH = (isShopColumnReduction && !skipRemark) ? 3 : 5;
  function splitShopName(shopName) {
    if (shopName && shopName.length > SHOP_NAME_SPLIT_LENGTH) {
      return [shopName.slice(0, SHOP_NAME_SPLIT_LENGTH), shopName.slice(SHOP_NAME_SPLIT_LENGTH)];
    } else {
      return [shopName];
    }
  }   

  // 横罫線
  page.drawLine({
    start: { x: marginLeft, y: tableStart_y },
    end: { x: width - marginRight, y: tableStart_y },
    thickness : 2,
    color: rgb(0, 0, 0),
    opacity : 1
  })

  Array.from(new Array(rowNumber)).forEach((_, index) => {
    page.drawLine({
      start: { x: marginLeft, y: tableDataStart_y - rowHeight * index},
      end: { x: width - marginRight, y: tableDataStart_y  - rowHeight * index},
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })
  })

  page.drawLine({
    start: { x: marginLeft, y: tableEnd_y },
    end: { x: width - marginRight, y: tableEnd_y },
    thickness : 2,
    color: rgb(0, 0, 0),
    opacity : 1
  })

  // 縦罫線と表ヘッダ
  Array.from(new Array(columnNumber)).forEach((_, index) => {
    let start_x = marginLeft + columnWidth * index
    page.drawLine({
      start: { x: start_x, y: tableStart_y},
      end: { x: start_x, y: tableEnd_y},
      thickness : 2,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    page.drawLine({
      start: { x: start_x + nameColumnLeft, y: tableStart_y},
      end: { x: start_x + nameColumnLeft, y: tableEnd_y},
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    customDrawText(page,'商品名', {
      x: start_x  + (nameColumnLeft + placeColumnLeft) / 2 - (columnNumber === 1 ? 18 : 12),
      y: tableStart_y - tableHeaderHeight / 2 - 4,
      size: columnNumber === 1 ? 12 : 8,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })
    
    page.drawLine({
      start: { x: start_x + placeColumnLeft, y: tableStart_y},
      end: { x: start_x + placeColumnLeft, y: tableEnd_y},
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    customDrawText(page,'産地', {
      x: start_x + (placeColumnLeft + sizeColumnLeft) / 2  - (columnNumber === 1 ? 12 : 8),
      y: tableStart_y - tableHeaderHeight / 2 - 4,
      size: columnNumber === 1 ? 12 : 8,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })

    page.drawLine({
      start: { x: start_x + sizeColumnLeft, y: tableStart_y},
      end: { x: start_x + sizeColumnLeft, y: tableEnd_y},
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    customDrawText(page,'規格', {
      x: start_x + (sizeColumnLeft + priceColumnLeft) / 2 - (columnNumber === 1 ? 12 : 8),
      y: tableStart_y - tableHeaderHeight / 2 - 4,
      size: columnNumber === 1 ? 12 : 8,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })

    // 価格欄
    page.drawLine({
      start: { x: start_x + priceColumnLeft, y: tableStart_y},
      end: { x: start_x + priceColumnLeft, y: tableEnd_y},
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })
    
    // 価格欄
    // 売価表示設定かつ営業用出力ではない場合
    if (outputPrice && isUsingSellingPrice && !isViewOriginalCost) {
      page.drawLine({
        start: { x: start_x + primePriceLeft, y: tableStart_y},
        end: { x: start_x + primePriceLeft, y: tableEnd_y},
        thickness : 1,
        color: rgb(0, 0, 0),
        opacity : 1
      });

      page.drawLine({
        start: { x: start_x + sellingPriceMarkUpRateLeft, y: tableStart_y},
        end: { x: start_x + sellingPriceMarkUpRateLeft, y: tableEnd_y},
        thickness : 1,
        color: rgb(0, 0, 0),
        opacity : 1
      });

      drawTextInBox(page, '売価', {
        x1: start_x + priceColumnLeft,
        x2: start_x + primePriceLeft,
        y1: tableStart_y,
        y2: tableStart_y - tableHeaderHeight + 2
      },{
        size: 12,
        font: fonts.mincho_font,
        xAlign: X_ALIGN_CENTER
      });

      drawTextInBox(page, '原価', {
        x1: start_x + primePriceLeft,
        x2: start_x + sellingPriceMarkUpRateLeft,
        y1: tableStart_y,
        y2: tableStart_y - tableHeaderHeight + 2
      },{
        size: 12,
        font: fonts.mincho_font,
        xAlign: X_ALIGN_CENTER
      });

      drawTextInBox(page, '値入', {
        x1: start_x + sellingPriceMarkUpRateLeft,
        x2: start_x + orderUnitColumnLeft,
        y1: tableStart_y,
        y2: tableStart_y - tableHeaderHeight + 2
      },{
        size: 12,
        font: fonts.mincho_font,
        xAlign: X_ALIGN_CENTER
      });

    } else if (outputPrice) {
      let unitPriceTitle = unitPrice === 2 ? 'キロ単価' : '価格';

      if (isUsingDeliveryPrice) {
        unitPriceTitle = isUsingOriginalMarketPrice ? "納品価格" : "案内価格";
      }

      drawTextInBox(page, unitPriceTitle, {
        x1: start_x + priceColumnLeft,
        x2: start_x + orderUnitColumnLeft,
        y1: tableStart_y,
        y2: tableStart_y - tableHeaderHeight + (columnNumber === 1 ? 2 : 0)
      },{
        size: columnNumber === 1 ? 12 : 8,
        font: fonts.mincho_font,
        xAlign: X_ALIGN_CENTER
      })
    }    

    page.drawLine({
      start: { x: start_x + orderUnitColumnLeft , y: tableStart_y},
      end: { x: start_x + orderUnitColumnLeft  , y: tableEnd_y},
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    // 店舗別・日付別注文数
    if (orderQuantityOutput) {

      page.drawLine({
        start: { x: start_x + orderUnitColumnLeft + 2, y: tableStart_y},
        end: { x: start_x + orderUnitColumnLeft + 2 , y: tableEnd_y},
        thickness : 1,
        color: rgb(0, 0, 0),
        opacity : 1
      })

      if (datePartition) {

        dateList.forEach((date, dateIndex) => {
          let monthDate = getMonthDateDisplay(date);
          let day = dayWeekToString(date.getDay())

          page.drawLine({
            start: { x: start_x + orderUnitColumnLeft + shopColumnWidth * dateIndex, y: tableStart_y},
            end: { x: start_x + orderUnitColumnLeft + shopColumnWidth * dateIndex , y: tableEnd_y},
            thickness : 1,
            color: rgb(0, 0, 0),
            opacity : 1
          });

          drawTextInBox(page, monthDate, {
            x1: start_x + orderUnitColumnLeft + shopColumnWidth * dateIndex,
            x2: start_x + orderUnitColumnLeft + shopColumnWidth * (dateIndex + 1),
            y1: tableStart_y,
            y2: tableStart_y - tableHeaderHeight / 2
          },{
            size: 11,
            xAlign: X_ALIGN_CENTER,
            font: fonts.mincho_bold_font,
            color: rgb(0, 0, 0)
          })

          drawTextInBox(page, day, {
            x1: start_x + orderUnitColumnLeft + shopColumnWidth * dateIndex,
            x2: start_x + orderUnitColumnLeft + shopColumnWidth * (dateIndex + 1),
            y1: tableStart_y - tableHeaderHeight / 2 + 2,
            y2: tableStart_y - tableHeaderHeight + 2
          },{
            size: 11,
            xAlign: X_ALIGN_CENTER,
            font: fonts.mincho_bold_font,
            color: rgb(0, 0, 0),
          })

        });   

      } else if (shopSummary) {

        page.drawLine({
          start: { x: marginLeft + orderUnitColumnLeft, y: tableStart_y - rowHeight },
            end: { x: marginLeft + remarkColumnLeft, y: tableStart_y - rowHeight },
            thickness : 1,
            color: rgb(0, 0, 0),
            opacity : 1
          })

        let lastCustomerId = 0;

        shops.forEach((shopInfo, shopIndex) => {
          let customerName = shopInfo.customerName;
          let shopName = shopInfo.shopName;

          if (outputCustomerName && lastCustomerId !== shopInfo.customerId) {

            page.drawLine({
              start: { x: start_x + orderUnitColumnLeft + shopColumnWidth * shopIndex, y: tableStart_y},
              end: { x: start_x + orderUnitColumnLeft + shopColumnWidth * shopIndex, y: tableEnd_y},
              thickness : 1,
              color: rgb(0, 0, 0),
              opacity : 1
            })

            page.drawLine({
              start: { x: start_x + orderUnitColumnLeft + shopColumnWidth * shopIndex + 2, y: tableStart_y},
              end: { x: start_x + orderUnitColumnLeft + shopColumnWidth * shopIndex + 2 , y: tableEnd_y},
              thickness : 1,
              color: rgb(0, 0, 0),
              opacity : 1
            })

            customDrawText(page,customerName, {
              x: start_x + orderUnitColumnLeft + shopColumnWidth * shopIndex + 4,
              y: tableStart_y - rowHeight / 2 - (columnNumber === 1 ? 5 : 3.5),
              size: columnNumber === 1 ? 10 : 7,
              font: fonts.mincho_font,
              color: rgb(0, 0, 0),
            })

          } else {
            page.drawLine({
              start: { x: start_x + orderUnitColumnLeft + shopColumnWidth * shopIndex, y: shopHeaderStart_y},
              end: { x: start_x + orderUnitColumnLeft + shopColumnWidth * shopIndex , y: tableEnd_y},
              thickness : 1,
              color: rgb(0, 0, 0),
              opacity : 1
            })

          }  
          
          // 店舗名列に対して店舗名が表示可能文字数よりも長い場合は、
          // 文字サイズを縮小して２行に改行して出力する
          if(shopName.length > SHOP_NAME_SPLIT_LENGTH){
            splitShopName(shopName).map((text,index)=>{
              customDrawText(page,text, {
                x: start_x + orderUnitColumnLeft + shopColumnWidth * (shopIndex + 1/2) - SHOP_NAME_SPLIT_LENGTH * (columnNumber === 1 ? 4.5 : 3.25),
                y: shopName.length == SHOP_NAME_SPLIT_LENGTH 
                ? (shopHeaderStart_y - rowHeight / 2 -3)
                : (shopHeaderStart_y - rowHeight * 1 / 3 -3 -(columnNumber === 1 ? 9 : 6.5)*index),
                size: columnNumber === 1 ? 9 : 6.5,
                font: fonts.mincho_bold_font,
                color: rgb(0, 0, 0),
              })
  
            })
          } else {
            customDrawText(page,shopName, {
              x: start_x + orderUnitColumnLeft + shopColumnWidth * (shopIndex + 1/2) - shopName.length * (columnNumber === 1 ? 5.5 : 4),
              y: shopHeaderStart_y - rowHeight / 2 - 5,
              size: columnNumber === 1 ? 11 : 8,
              font: fonts.mincho_bold_font,
              color: rgb(0, 0, 0),
            })
          }

          lastCustomerId = shopInfo.customerId;

        });

      } else if (asSendingLabel) {

        customDrawText(
          page,
          "納品数",
          {
            x: start_x + orderUnitColumnLeft + shopColumnWidth / 2 - (columnNumber === 1 ? 16 : 12),
            y: tableStart_y - tableHeaderHeight / 2 - 4,
            size: columnNumber === 1 ? 11 : 8,
            font: fonts.mincho_font,
            color: rgb(0, 0, 0),
          }
        )

      } else {

        customDrawText(page,columnNumber === 1 ? "発注数量":"数量", {
          x: start_x + orderUnitColumnLeft + shopColumnWidth / 2 - (columnNumber === 1 ? 22 : 8),
          y: tableStart_y - tableHeaderHeight / 2 - 4,
          size: columnNumber === 1 ? 11 : 8,
          font: fonts.mincho_font,
          color: rgb(0, 0, 0),
        })

      }
    }

    if (!skipRemark) {
      page.drawLine({
        start: { x: start_x + remarkColumnLeft, y: tableStart_y},
        end: { x: start_x + remarkColumnLeft, y: tableEnd_y},
        thickness : 1,
        color: rgb(0, 0, 0),
        opacity : 1
      })

      customDrawText(page,'備考', {
        x: start_x + (remarkColumnLeft + originalMarketPriceLeft) / 2 - (columnNumber === 1 ? 12 : 8),
        y: tableStart_y - tableHeaderHeight / 2 - 4,
        size: columnNumber === 1 ? 12 : 8,
        font: fonts.mincho_font,
        color: rgb(0, 0, 0),
      })
    }

    // 納品価格・案内価格
    if (outputPrice && isUsingOriginalMarketPrice) {
      page.drawLine({
        start: { x: start_x + originalMarketPriceLeft, y: tableStart_y},
        end: { x: start_x + originalMarketPriceLeft, y: tableEnd_y},
        thickness : 1,
        color: rgb(0, 0, 0),
        opacity : 1
      })

      // 売価表示設定でない場合は案内価格を表示
      // 売価表示設定かつ営業用出力ではない場合は仲卸業者への納品価格を表示
      // 売価表示設定かつ営業用出力である場合は案内価格を表示
      drawTextInBox(page, (isUsingSellingPrice && !isViewOriginalCost) ? "納品価格": "案内価格", {
        x1: start_x + originalMarketPriceLeft,
        x2: start_x + columnWidth,
        y1: tableStart_y,
        y2: tableStart_y - tableHeaderHeight + 2
      },{
        size: columnNumber === 1 ? 12 : 8,
        xAlign: X_ALIGN_CENTER,
        font: fonts.mincho_font,
      })
    }

  })

  page.drawLine({
    start: { x: width - marginRight, y: tableStart_y},
    end: { x: width - marginRight, y: tableEnd_y},
    thickness : 2,
    color: rgb(0, 0, 0),
    opacity : 1
  })
}

// 価格表データ出力
export const outputVarticalOrderFormTableProductData = (page, pageParameter, rowIndex, columnIndex, outputData) => {

  const {
    marginLeft,
    tableStart_y ,  
    rowHeight ,
    columnWidth ,
    columnNumber,
    shopColumnWidth,
    shopSummary,
    shopNumber,
    nameColumnLeft,
    placeColumnLeft ,
    sizeColumnLeft ,
    priceColumnLeft,
    orderUnitColumnLeft,
    remarkColumnLeft,
    fonts,
    tableDataStart_y,
    skipOrderUnit,
    orderQuantityOutput,
    orderQuantityColumnNumber,
    skipRemark,
    isUsingSellingPrice,
    sellingPriceMarkUpRateLeft,
    primePriceLeft,
    isUsingOriginalMarketPrice,
    originalMarketPriceLeft,
    isUsingDeliveryPrice,
    isViewOriginalCost,
    isShopColumnReduction,
    outputPrice
  } = pageParameter;

  const {
    name,
    origin,
    rank,
    productClass,
    weight,
    weightUnit,
    packing,
    quantity,
    isShortage,
    price,
    primePriceMarkUpRate,
    sellingPriceMarkUpRate,
    unit,
    remarks,
    outputAsFirstOfType,
    deliveryPriceAdditionCd,
    deliveryPriceAdditionAmount
  } = outputData;

  const dataStart_x = marginLeft + columnWidth * columnIndex

  const text_y = tableDataStart_y - rowHeight * (rowIndex + 1 / 2) - 4
  let text_y1 = tableDataStart_y - rowHeight * rowIndex

  let outputOrigin = origin ? origin : "";

  let outputUnit = unit ? unit: "";

  let outputSize_1 = "";
  let outputSize_2 = "";

  let outputWeight = weightUnit ? weight.toString() + weightUnit : "";

  Array.from([rank, productClass, outputWeight, packing, quantity]).forEach((item) => {
    if (item && item.length > 0) {
      if (outputSize_2.length > 0 || (outputSize_1.length > 0 && outputSize_1.length + item.length > 8)) {
        outputSize_2 += item + " ";
      } else {
        outputSize_1 += item + " ";
      }
    }
  })

  if (outputAsFirstOfType) {
    page.drawLine({
      start: { x: dataStart_x, y: tableDataStart_y - rowHeight * rowIndex - 2 },
      end: { x: dataStart_x + columnWidth,  y: tableDataStart_y - rowHeight * rowIndex - 2},
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })
  }

  /** 価格フォント */
  let priceFont = columnNumber > 1 ? fonts.helvetica_bold_font : fonts.mincho_bold_font;

  let textInBoxOption = {
    font: fonts.mincho_font,
    size: columnNumber === 1 ? 11 : 8,
    xPadding: 0,
    yPadding: 0,
    xAlign: X_ALIGN_CENTER
  } 
  
  // 商品名
  drawTextInBox(page, name, {
    x1: dataStart_x + nameColumnLeft,
    x2: dataStart_x + placeColumnLeft,
    y1: text_y1,
    y2: text_y1 - rowHeight + 2
  },{
    ...textInBoxOption,
    size: columnNumber === 1 ? 15 : 9,
    font: fonts.mincho_bold_font
  });
  
  // 産地
  drawTextInBox(page, outputOrigin, {
    x1: dataStart_x + placeColumnLeft,
    x2: dataStart_x + sizeColumnLeft,
    y1: text_y1,
    y2: text_y1 - rowHeight + 2
  }, textInBoxOption);

  // 規格
  if (outputSize_2.length > 0) {

    drawTextInBox(page, outputSize_1, {
      x1: dataStart_x + sizeColumnLeft,
      x2: dataStart_x + priceColumnLeft,
      y1: text_y1,
      y2: text_y1 - rowHeight / 2
    }, {
      ...textInBoxOption,
      size: columnNumber === 1 ? 10 : 8
    });

    drawTextInBox(page, outputSize_2, {
      x1: dataStart_x + sizeColumnLeft,
      x2: dataStart_x + priceColumnLeft,
      y1: text_y1 - rowHeight / 2,
      y2: text_y1 - rowHeight + 2
    }, {
      ...textInBoxOption,
      size: columnNumber === 1 ? 10 : 8
    });

  } else {
    drawTextInBox(page, outputSize_1, {
      x1: dataStart_x + sizeColumnLeft,
      x2: dataStart_x + priceColumnLeft,
      y1: text_y1,
      y2: text_y1 - rowHeight + 2
    }, {
      ...textInBoxOption,
      size: columnNumber === 1 ? 10 : 8
    });
  }
  
  // 価格
  // 売価表示設定かつ営業用出力でない場合
  if(outputPrice && isUsingSellingPrice && !isViewOriginalCost) {
    // 納品価格加算を加算する場合は納品価格を計算　※ただし、入荷未定の場合は計算不可
    let displayPrice = (!isShortage && isUsingDeliveryPrice) ? getDeliveryPriceCalculation(deliveryPriceAdditionCd)(price, deliveryPriceAdditionAmount) : price;
    
    let displayPrimePrice = isShortage ? '-' : getPrimePrice(displayPrice, primePriceMarkUpRate).toLocaleString();
    let displaySellingPriceMarkUpRate = isShortage ? '-' : decimalToPercentDecimal(new Decimal(sellingPriceMarkUpRate)).toFixed(2);
    let displaySellingPrice = isShortage ? '-' : getSellingPrice(displayPrice, primePriceMarkUpRate, sellingPriceMarkUpRate).toLocaleString();

    // 売価
    drawTextInBox(page, displaySellingPrice, {
      x1: dataStart_x + priceColumnLeft,
      x2: dataStart_x + primePriceLeft,
      y1: text_y1,
      y2: text_y1 - rowHeight + 2
    }, {
      ...textInBoxOption,
      font: fonts.mincho_bold_font,
      xAlign: X_ALIGN_RIGHT,
      xPadding: 2,
      size: 15
    });

    // 原価
    drawTextInBox(page, displayPrimePrice, {
      x1: dataStart_x + primePriceLeft,
      x2: dataStart_x + sellingPriceMarkUpRateLeft,
      y1: text_y1,
      y2: text_y1 - rowHeight + 2
    }, {
      ...textInBoxOption,
      xAlign: X_ALIGN_RIGHT,
      xPadding: 2,
      font: fonts.mincho_bold_font,
      size: 15
    });

    // 値入率
    drawTextInBox(page, displaySellingPriceMarkUpRate, {
      x1: dataStart_x + sellingPriceMarkUpRateLeft,
      x2: dataStart_x + orderUnitColumnLeft,
      y1: text_y1,
      y2: text_y1 - rowHeight + 2
    }, {
      ...textInBoxOption,
      xAlign: X_ALIGN_RIGHT,
      xPadding: 2,
      size: 12
    });

  } else if (outputPrice) {
    // 価格・納品価格
    let displayPrice = isShortage ? "-" : price.toLocaleString();
    if (!isShortage && isUsingDeliveryPrice && isUsingOriginalMarketPrice) {
      displayPrice
        = getDeliveryPriceCalculation(deliveryPriceAdditionCd)(price, deliveryPriceAdditionAmount).toLocaleString()
    }

    drawTextInBox(page, displayPrice, {
      x1: dataStart_x + priceColumnLeft,
      x2: dataStart_x + orderUnitColumnLeft,
      y1: text_y1,
      y2: text_y1 - rowHeight + 2
    }, {
      ...textInBoxOption,
      font: priceFont,
      xAlign: X_ALIGN_RIGHT,
      xPadding: 2,
      size: columnNumber === 1 ? 15 : 11,
    });
  }  

  // 注文数量
  if (orderQuantityOutput && !skipOrderUnit) {
    // 店舗をまとめて出力する場合、４店舗より多いと店舗列が表示しきれなくなるため、
    // 店舗列幅を縮小する。それに合わせて発注単位の文字サイズも縮小する
    const outputUnitFontSize = ((isShopColumnReduction && !skipRemark) ? 9 : (columnNumber === 1 ? 11 : 7));
    Array.from(Array(orderQuantityColumnNumber)).forEach((_, shop_i) => {
      customDrawText(page,outputUnit, {
        x: dataStart_x + orderUnitColumnLeft + shopColumnWidth * (shop_i + 1) - fonts.mincho_font.widthOfTextAtSize(outputUnit, outputUnitFontSize) - (columnNumber === 1 ? 4 : 2),
        y: text_y - rowHeight / 2 + 8,
        size: outputUnitFontSize,
        font: fonts.mincho_font,
        color: rgb(0, 0, 0),
      })
    })        
  }

  // 備考
  if (!skipRemark) {

    drawTextInBox(page, remarks, {
      x1: dataStart_x + remarkColumnLeft,
      x2: dataStart_x + originalMarketPriceLeft,
      y1: text_y1,
      y2: text_y1 - rowHeight + 2
    }, {
      ...textInBoxOption,
        size: columnNumber === 1 ? 8.5 : 8,
        font: fonts.mincho_font,
      xAlign: X_ALIGN_LEFT,
      xPadding: 2,
      lineBreaking: true,
      });
    }

  // 納品価格・案内価格
  if (outputPrice && isUsingOriginalMarketPrice) {
    // 納品価格加算を加算する場合は納品価格を計算　※ただし、入荷未定の場合は計算不可
    // 売価表示設定でない場合は案内価格を表示
    // 売価表示設定かつ営業用出力ではない場合は仲卸業者への納品価格を表示
    // 売価表示設定かつ営業用出力である場合は案内価格を表示
    let displayPrice = (!isShortage && isUsingSellingPrice && isUsingDeliveryPrice && !isViewOriginalCost) ? 
                        getDeliveryPriceCalculation(deliveryPriceAdditionCd)(price, deliveryPriceAdditionAmount) : price;

    drawTextInBox(page, displayPrice.toLocaleString(), {
      x1: dataStart_x + originalMarketPriceLeft,
      x2: dataStart_x + columnWidth,
      y1: text_y1,
      y2: text_y1 - rowHeight + 2
    }, {
      ...textInBoxOption,
      font: priceFont,
      xAlign: X_ALIGN_RIGHT,
      xPadding: 2,
      size: columnNumber === 1 ? 15 : 11
    });
  }
  
}

const createFooter = (page, pageParameter) => {
  const {
    width,
    margin,
    fonts
  } = pageParameter

  customDrawText(page,"丸伊伊那青果(株)", {
    x: width - margin - 340,
    y: 15,
    size: 20,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })

  customDrawText(page, "FAX: (0265) zz-wwww", {
    x: width - margin - 160,
    y: 15,
    size: 15,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })
}

// 価格表(縦)PDF文書作成
async function createVerticalOrderFormPDFDocumentInfo(
    marketPriceInfo,
    priceInfoList,
    shops,
    destinations,
    isSample,
    shippingDateInfo,
    pdfSetting
) {

  const pdfDoc = await createPDFDocument();
  
  const genminchoArrayBuffer = await getFontArrayBuffer(genmincho);
  const genminchoBoldArrayBuffer = await getFontArrayBuffer(genmincho_bold);
  
  //日本語フォント読込
  const mincho_font = await pdfDoc.embedFont(genminchoArrayBuffer);
  const mincho_bold_font = await pdfDoc.embedFont(genminchoBoldArrayBuffer);
  const helvetica_bold_font = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

  const [ width, height ] = PageSizes.A4

  const pageParameter = getVerticalOrderFormPageParameter(
    width, height, {mincho_font, mincho_bold_font, helvetica_bold_font}, shops, destinations, shippingDateInfo, pdfSetting
  );
  let {rowNumber, columnNumber, shopSummary, productTypePartition, destinationOutputCd } = pageParameter  
  
  // ページ数の判定
  let productPartitionList = getProductPartitionList(priceInfoList, productTypePartition, rowNumber)

  let columnCount = productPartitionList
    .map((productPartition) => Math.ceil(productPartition.length / rowNumber))
    .reduce((prevCnt, thisCnt) => prevCnt + thisCnt, 0);

  let pageCount = Math.ceil(columnCount / columnNumber);

  // ページの生成
  let pages = Array.from(new Array(pageCount)).map((_) => {
    let page = pdfDoc.addPage([width, height]);
    createVerticalOrderFormTableBones(page, pageParameter);   

    return page;
  });

  var lastName = "";
  var lastOrigin = "";
  var lastPriceDetailTypeId = 0;

  var totalDataIndex = 0;

  productPartitionList.forEach((dataList) => {
    if (dataList.length === 0) {
      return;
    }

    totalDataIndex = Math.ceil(totalDataIndex / rowNumber) * rowNumber
    
    dataList.forEach((data, index) => {
      let rowIndex = totalDataIndex % rowNumber;
      let columnIndex = Math.floor(totalDataIndex / rowNumber) % columnNumber;
      let pageIndex = Math.floor(totalDataIndex / (rowNumber * columnNumber));

      let displayOrigin = getDisplayOriginWithOther(data.origin, data.isOriginOther);

      let outputAsFirstOfType
        = !productTypePartition
          && (data.priceDetailTypeId !== lastPriceDetailTypeId)
          && totalDataIndex > 0;

      if (index % rowNumber === 0 || outputAsFirstOfType) {
        lastName = "";
        lastOrigin = "";
      }

      let outputData = {
        ...data,
        name: (lastName === data.productName ? "〃" : data.productName),
        origin: (lastName === data.productName && lastOrigin === displayOrigin ? "〃" : displayOrigin),
        size: getDisplaySize(data.rank, data.productClass, data.weight, data.weightUnit, data.packing, data.quantity),
        price: data.isShortage ? "-" : data.price,
        unit: data.orderingUnit,
        outputAsFirstOfType: outputAsFirstOfType
      }

      outputVarticalOrderFormTableProductData(pages[pageIndex], pageParameter, rowIndex, columnIndex, outputData);
     
      lastName = data.productName;
      lastOrigin = displayOrigin;
      lastPriceDetailTypeId = data.priceDetailTypeId;

      totalDataIndex += 1;
    })
  })

  pdfDoc.setCreator("丸伊伊那青果　事務担当");

  return await Promise.all((isSample ? [{customerName:marketPriceInfo.marketPriceName,shopName:""}] : destinations).map(async (destinationInfo) => {
    let newPdfDoc = await pdfDoc.copy();

    //埋込フォント使用
    newPdfDoc.registerFontkit(fontkit);

    let newFonts = {
      mincho_font: await newPdfDoc.embedFont(genminchoArrayBuffer),
      mincho_bold_font: await newPdfDoc.embedFont(genminchoBoldArrayBuffer),
      helvetica_bold_font: await pdfDoc.embedFont(StandardFonts.HelveticaBold)
    }
    let newPageParameter = {...pageParameter, fonts: newFonts};
    return await createVerticalOrderFormPDFFromDocument(
      newPdfDoc,
      "市況価格表",
      getDestinationOutputName(destinationInfo, shopSummary, destinationOutputCd),
      shippingDateInfo,
      newPageParameter,
      marketPriceInfo
    )
  }));

}

async function createVerticalOrderFormPDFFromDocument(pdfDoc, title, destinationName, shippingDateInfo, pageParameter, marketPriceInfo) {
  let pages = pdfDoc.getPages();
  let outputPageIndex = pages.length > 1;
  pages.forEach((page, pageIndex) => createVerticalOrderFormHeader(marketPriceInfo,page, pageIndex, title, destinationName, shippingDateInfo, pageParameter, outputPageIndex))
  
  // 選択されたページに対する余計なページを削除
  const printPages = getPrintPages(pageParameter.printPageStr, pdfDoc.getPageCount())

  const deletePages
    = Array.from(new Array(pdfDoc.getPageCount()))
      .map((_, pageIndex) => pageIndex)
      .filter((pageIndex) => !printPages.includes(pageIndex + 1))
      .reverse();

  deletePages.forEach((pageIndex) => {
    pdfDoc.removePage(pageIndex);
  });
  
  return await pdfDoc.save();
}


export async function createVerticalOrderFormPDF(
  marketPriceId, shops, destinations, isSample, shippingDateInfo, pdfSetting, marketPriceHistoryDate = null
) {
  let marketPriceResponse = await postMarketPriceSearchTableInfoListAPI({marketPriceId, marketPriceHistoryDate});
  let marketPriceInfo = marketPriceResponse.marketPriceTableInfoList[0];
  let res = await postMarketPriceSearchInfoListAPI({marketPriceId, marketPriceHistoryDate});
  let marketPriceInfoList = res.marketPriceInfoList
                .filter((data) => data.isCustomerOrder)
                .map((data)=>({
                  ...data, 
                  price: data.marketPrice,
                  sellingPriceMarkUpRate : data.sellingPriceMarkUpRate || marketPriceInfo.sellingPriceMarkUpRate,
                  primePriceMarkUpRate: data.primePriceMarkUpRate || marketPriceInfo.primePriceMarkUpRate,
                  deliveryPriceAdditionCd: marketPriceInfo.deliveryPriceAdditionCd,
                  deliveryPriceAdditionAmount: marketPriceInfo.deliveryPriceAdditionAmount
                }));
  return await createVerticalOrderFormPDFDocumentInfo(
    marketPriceInfo,
    marketPriceInfoList,
    shops,
    destinations,
    isSample,
    shippingDateInfo,
    pdfSetting
  );
 
}

// あて名取得
const getDestinationOutputName = (destinationInfo, shopSummary, outputCd) => {
  if (outputCd == 2) {
    return "御取引先様各位";
  }
  if (outputCd == 3) {
    return "　　　　　　　　　　　　様";
  }

  return getOutputDestination(destinationInfo, shopSummary, false);

}
